// useTour — convenience hook re-exporting the tour context's start/stop API.

import { useTourContext } from './TourProvider';

export default function useTour() {
  return useTourContext();
}
